import {ErrorMessage, Field, Form, Formik} from "formik";
import React, {useState} from "react";
import styles from "../../styles/list_styles.module.scss";
import Button from "../../components/Button/Button";

import {ReactComponent as Download} from "../../assets/icons/download.svg";
import {ReactComponent as Pencil} from "../../assets/icons/pencil.svg";
import {ReactComponent as Trash} from "../../assets/icons/trash.svg";

import {BarLoader} from "react-spinners";
import {useNavigate} from "react-router-dom";
import {deleteTeam, getTeams, serializeArray} from "../../services/services";
import Pagination from "../../components/Pagination/Pagination";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import {useMutation, useQuery} from "react-query";
import {toast} from "react-toastify";
import {queryClient} from "../../services/queryClient";
import {getToken} from "../../services/auth";
import Select2 from "react-select";
import {stylesSelect} from "../../helper/stylesSelect";
import {IGetTeams, ITeamsResponse} from "../../ts/interfaces/Team/interface";

const Teams: React.FC = () => {
    document.title = 'Admin - Times';

    const [filter, setFilter] = useState<IGetTeams>({
        id: null,
        name: null,
        country: null,
        league: null,
        page: 1,
        limit: 50,
    });

    const [open, setOpen] = useState(false);
    const [id, setId] = useState<number | null>(null);
    const [selectFilters, setSelectFilters] = useState({
        country: "",
        league: ""
    });

    const navigate = useNavigate();

    const {data, isLoading} = useQuery<ITeamsResponse>(
        ["teams", filter],
        () => getTeams(filter),
        {
            staleTime: Infinity,
        }
    );

    const handleDownloadCSV = () => {
        let link = document.getElementById("download_csv");
        link?.click();
    };

    const mutateDeleteTeam = useMutation(
        () => {
            return deleteTeam(id as number);
        },
        {
            onSettled: (data) => {
                if (data?.data?.success) {
                    queryClient.invalidateQueries(["teams", filter]);
                    toast.success('Deletado com sucesso');
                } else {
                    toast.error("Erro ao deletar time. " + data?.data?.msg);
                }
                setOpen(false);
            },
            onError: () => {
                toast.error("Erro ao deletar time.");
            },
        }
    );


    return (
        <div className={styles.container}>
            <h1>Times</h1>

            <Formik
                initialValues={{
                    id: "",
                    name: "",
                    country: "",
                    league: "",
                }}
                onSubmit={(values) => {
                    setFilter({
                        ...filter,
                        id: values.id && values.id !== '' ? parseInt(values.id) : null,
                        name: values.name,
                        country: selectFilters.country,
                        league: selectFilters.league,
                        page: 1,
                    });
                }}
            >
                <Form className={styles.searchProducts}>
                    <div className={styles.alignInput}>
                        <Field
                            name="id"
                            type="text"
                            placeholder="Pesquisar por ID"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="id"
                            component="div"
                            className={styles.error}
                        />

                        <Field
                            name="name"
                            type="text"
                            placeholder="Pesquisar por nome"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="name"
                            component="div"
                            className={styles.error}
                        />

                        <div className={styles.groupInput}>
                            <Select2
                                styles={stylesSelect}
                                options={[
                                    {value: "BR", label: "Brasil"},
                                    {value: "AR", label: "Argentina"},
                                    {value: "FR", label: "França"},
                                    {value: "IT", label: "Itália"},
                                    {value: "DE", label: "Alemanha"},
                                    {value: "ES", label: "Espanha"},
                                    {value: "PT", label: "Portugal"},
                                    {value: "GB", label: "Inglaterra"},
                                    {value: "US", label: "Estados Unidos"},
                                    {value: "MX", label: "México"},
                                    {value: "JP", label: "Japão"},
                                    {value: "NL", label: "Holanda"},
                                    {value: "BE", label: "Bélgica"},
                                    {value: "CH", label: "Suíça"},
                                    {value: "UR", label: "Uruguai"},
                                    {value: "SA", label: "Arábia Saudita"},
                                ]}
                                onChange={(selectedOption) => {
                                    const selected = selectedOption?.value || "";
                                    setSelectFilters((prev) => ({...prev, country: selected.toString()}));

                                }}
                                placeholder="Pesquisar por país"
                            />
                        </div>

                        <div className={styles.groupInput}>
                            <Select2
                                styles={stylesSelect}
                                options={[
                                    {value: "Campeonato Brasileiro", label: "Campeonato Brasileiro"},
                                    {value: "La Liga", label: "La Liga"},
                                    {value: "Serie A", label: "Serie A"},
                                    {value: "Bundesliga", label: "Bundesliga"},
                                    {value: "Ligue 1", label: "Ligue 1"},
                                    {value: "Premier League", label: "Premier League"},
                                    {value: "Primeira Liga", label: "Primeira Liga"},
                                    {value: "Eredivisie", label: "Eredivisie"},
                                    {value: "Primera División", label: "Primera División"},
                                    {value: "Liga MX", label: "Liga MX"},
                                    {value: "Major League Soccer", label: "Major League Soccer"},
                                    {value: "J-League", label: "J-League"},
                                    {value: "Saudi Pro League (SPL)", label: "Saudi Pro League (SPL)"},
                                ]}
                                onChange={(selectedOption) => {
                                    const selected = selectedOption?.value || "";
                                    setSelectFilters((prev) => ({...prev, league: selected.toString()}));

                                }}
                                placeholder="Pesquisar por Liga"
                            />
                        </div>
                    </div>
                    <div className={styles.alignButtonSearch}>
                        <Button
                            type="submit"
                            width="115px"
                            height="39px"
                            theme="primary"
                            fontSize="14px"
                            disabled={isLoading}
                        >
                            Pesquisar
                        </Button>
                    </div>
                </Form>
            </Formik>

            <div className={styles.alignButtonCsvRegister}>
                <Button
                    width="115px"
                    height="39px"
                    theme="close"
                    icon={<Download/>}
                    fontSize="14px"
                    onClick={() => handleDownloadCSV()}
                    disabled={isLoading}
                >
                    CSV
                </Button>
                <Button
                    width="115px"
                    height="39px"
                    theme="primary"
                    fontSize="14px"
                    onClick={() => navigate("/team/create")}
                    disabled={isLoading}
                >
                    Cadastrar
                </Button>
            </div>
            <div className={styles.dNone}>
                <a
                    id="download_csv"
                    rel="noopener noreferrer"
                    href={
                        process.env.REACT_APP_API_URL +
                        "/admin/team/export?" +
                        serializeArray(filter) +
                        "&token=" +
                        getToken()
                    }
                    target="_blank"
                    download
                ></a>
            </div>

            <div className={styles.tableProducts}>
                {isLoading ? (
                    <div className={styles.alignCenter}>
                        <span>Carregando</span>
                        <BarLoader
                            color={"#2b6cded9"}
                            loading={isLoading}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                ) : (
                    <>
                        {data && data.data.teams.length > 0 ? (
                            <table>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Nome</th>
                                    <th>Abreviação</th>
                                    <th>País</th>
                                    <th>Liga</th>
                                    <th>Produtos</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.data.teams.map(
                                    (team) => (
                                        <tr key={team.id}>
                                            <td>{team.logo && <img className={styles.icon} src={team.logo}
                                                                   alt={`Logo ${team.name}`}/>}</td>
                                            <td>{team.name}</td>
                                            <td>{team.abbreviation}</td>
                                            <td>{team.country}</td>
                                            <td>{team.league}</td>
                                            <td>{team.products}</td>
                                            <td>
                                                <button
                                                    className={
                                                        styles.editProducts
                                                    }
                                                    onClick={() =>
                                                        navigate(
                                                            `/team/create/${team.id}`
                                                        )
                                                    }
                                                >
                                                    <Pencil/>
                                                </button>
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        setId(
                                                            team.id
                                                        );
                                                        setOpen(true);
                                                    }}
                                                    className={
                                                        styles.editProducts
                                                    }
                                                >
                                                    <Trash/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )}
                                </tbody>
                            </table>
                        ) : (
                            <div className={styles.alignCenter}>
                                <span>Nenhum registro encontrado.</span>
                            </div>
                        )}
                    </>
                )}
            </div>
            {data && (
                <Pagination
                    currentPage={data.data.currentPage}
                    lastPage={data.data.lastPage}
                    onPageChange={(payload: number) =>
                        setFilter({...filter, page: payload})
                    }
                />
            )}

            {open && id && (
                <ModalConfirm
                    propsFunction={mutateDeleteTeam.mutate}
                    open={open}
                    setOpen={setOpen}
                    loading={mutateDeleteTeam.isLoading}
                >
                    <span>Essa ação é irreversível!</span>
                    <span>Tem certeza que deseja deletar o time?</span>
                </ModalConfirm>
            )}
        </div>
    );
};

export default Teams;
